<nz-modal
  nzTitle="Edit Line Items"
  nzClosable="true"
  nzWidth="922px"
  nzMaskClosable="false"
  nzWrapClassName="edit-line-item-modal-container vertical-center-modal"
  nzVisible="true"
  (nzOnCancel)="closeEditModal()"
>
<ng-container *nzModalContent>
  <div class="content" *ngIf="!isLoading">
    <app-line-item-modal
      [addColTableData]="addColTableData"
      [tickers]="[ticker]"
      [max]="max"
      [maxHeight]="maxHeight"
      [stdLineItems]="stdLineItems"
      [isLIMModal]="isLIMModal"
      [marketItemsData]="marketItemsData"
      (updateComp)="onUpdateLineItems($event)"
    ></app-line-item-modal>
  </div>
  <div *ngIf="isLoading">
    <ul nz-menu style="border: none">
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7, 8]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</ng-container>
  <div *nzModalFooter>
    <span (click)="restoreDefault()" class="restore-default">
      Restore Default Line Items
    </span>
    <button nz-button nzType="border" (click)="closeEditModal()">
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="this.isSaveDisabled"
      (click)="saveLineItems()"
    >
      Save
    </button>
  </div>
</nz-modal>
